import { ordersSlice } from './slice';

export * from './state';
export * from './license';

const Actions = ordersSlice.actions;
const Reducer = ordersSlice.reducer;

export { Reducer, Actions };
